var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 0.428921C13.6094 -0.142974 14.5164 -0.142974 15.0803 0.428921C15.6253 0.981494 15.6253 1.90116 15.0803 2.45245L4.85869 12.8174H38.5888C39.375 12.8187 40 13.4524 40 14.2497C40 15.047 39.375 15.7013 38.5888 15.7013H4.85869L15.0803 26.0469C15.6253 26.6188 15.6253 27.5398 15.0803 28.0911C14.5164 28.663 13.6081 28.663 13.0645 28.0911L0.422992 15.2724C-0.140997 14.7198 -0.140997 13.8002 0.422992 13.2489L13.0645 0.428921Z",
    fill: "url(#paint0_linear_201_1940)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_1940",
    x1: 40,
    y1: 14.26,
    x2: 0,
    y2: 14.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/Layer2.ada826e1c25af52c892b643179ce7a6a.svg";
export { ForwardRef as ReactComponent };